const setURLParam = (keyOrParams, value) => {
  const url = new URL(window.location.href);

  if (typeof keyOrParams === 'object' && keyOrParams !== null) {
    Object.entries(keyOrParams).forEach(([key, val]) => {
      url.searchParams.set(key, val);
    });
  } else if (typeof keyOrParams === 'string') {
    url.searchParams.set(keyOrParams, value);
  }

  window.history.pushState({}, '', url);
};

const resetParam = () => {
  const url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState({}, '', url);
};

export { setURLParam, resetParam };